import axios from 'axios';
import Booking from "../../models/Booking";
import BookingItem from "../../models/BookingItem";

export const getAllBooking = async () => {
    const url = `/api/v1/user_profile/bms/bookings`;
    const res = await axios.get(url);
    return res.data.map(b => new Booking(b));
};

export const getBooking = async (id) => {
    const url = `/api/v1/user_profile/bms/bookings/${id}`;
    const res = await axios.get(url);
    return new Booking(res.data);
};

export const createBooking = async (booking) => {
    const url = `/api/v1/user_profile/bms/bookings`;
    const res = await axios.post(url, booking);
    return new Booking(res.data);
};

export const updateBooking = async (bookingId, booking) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}`;
    const res = await axios.put(url, booking);
    return new Booking(res.data);
};

export const updateBookingPeriod = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/period`;
    const res = await axios.patch(url, data);
    return new Booking(res.data);
};

export const createBookingItem = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_items`;
    const res = await axios.post(url, data);
    return new BookingItem(res.data);
};

export const updateBookingItem = async (bookingItemId, data) => {
    const url = `/api/v1/user_profile/bms/booking_items/${bookingItemId}`;
    const res = await axios.patch(url, data);
    return new BookingItem(res.data);
};

export const deleteBookingItem = async (bookingItemId, data) => {
    const url = `/api/v1/user_profile/bms/booking_items/${bookingItemId}`;
    const res = await axios.delete(url, data);
    return  new BookingItem(res.data ?? {});
};

export const deleteBooking = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}`;
    await axios.delete(url);
}

export const cancelBooking = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/cancel`;
    const res = await axios.post(url);
    return new Booking(res.data);
}

export const sendOnlineCheckInEmail = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/send_online_check_in_email`;
    const res = await axios.get(url);
    return new Booking(res.data);
};

export const addGuest = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/guest_documents`;
    await axios.post(url, data);
}

export const updateGuest = async (guestId, data) => {
    const url = `/api/v1/user_profile/bms/guest_documents/${guestId}`;
    await axios.patch(url, data);
}

export const deleteGuest = async (guestId) => {
    const url = `/api/v1/user_profile/bms/guest_documents/${guestId}`;
    await axios.delete(url);
}

export const getAvailability = async (data) => {
    const url = `/api/v1/user_profile/bms/availability`;
    const res = await axios.get(url, {params: data});
    return res.data;
}

export const getLocalTouristTaxExclusions = async () => {
    const url = '/api/v1/user_profile/bms/local_tourist_tax_exclusions';
    const res = await axios.get(url);
    return res.data;
}

export const createCheckIn = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/check_ins`;
    const res = await axios.post(url, data);
    return res.data;
}

export const cancelCheckIn = async (checkInId) => {
    const url = `/api/v1/user_profile/bms/check_ins/${checkInId}/cancel`;
    const res = await axios.post(url);
    return res.data;
}

export const createCheckOut = async (bookingId, data) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/check_outs`;
    const res = await axios.post(url, data);
    return res.data;
}

export const checkInCreateAlloggiatiSync = async (checkInId) => {
    const url = `/api/v1/user_profile/bms/check_ins/${checkInId}/alloggiati_sync`;
    const res = await axios.post(url);
    return res.data;
}

export const createBookingConfirmationDocument = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_confirmation_document`;
    const res = await axios.post(url);
    return res.data;
}

export const sendBookingConfirmationDocumentEmail = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_confirmation_document/email`;
    const res = await axios.post(url);
    return res.data;
}

export const getBookingConfirmationDocument = async (bookingId) => {
    const url = `/api/v1/user_profile/bms/bookings/${bookingId}/booking_confirmation_document`;
    const res = await axios.get(url);
    return res.data;
}